"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGACY_RESET_PASSWORD_PATTERN = exports.INVITATION_PASSWORD_MAX_LENGTH = exports.INVITATION_PASSWORD_PATTERN = void 0;
exports.validatePasswordConfirmation = validatePasswordConfirmation;
/** Core applicant password policy; the Applications API remains authoritative. */
exports.INVITATION_PASSWORD_PATTERN = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
exports.INVITATION_PASSWORD_MAX_LENGTH = 50;
exports.LEGACY_RESET_PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#.*])[A-Za-z\d@$!%*?&#.]{8,}$/i;
function validatePasswordConfirmation(password, confirmation) {
    return password === confirmation || 'Passwords do not match';
}
